// import React from "react"
import * as React from 'react'

import { Helmet } from "react-helmet"
import { withPrefix, Link, useStaticQuery, graphql } from "gatsby"

import 'bootstrap/dist/css/bootstrap.min.css';
import "../css/style.css"
import "../css/custom.css"

// import Header from './header'
import Navi from "./Navi";
import Footer from "./Footer";

import { Container } from 'react-bootstrap'
import SimpleReactLightbox from 'simple-react-lightbox'

// export default function Layout({ children }) {
//   return (
//     <div>
//     <Helmet>
//       <title>WireFrame</title>
//       <link href="/favicon.ico" rel="shortcut icon" type="image/x-icon" />
//       <link href='https://unpkg.com/boxicons@2.0.9/css/boxicons.min.css' rel='stylesheet' />
//       <link href="https://unicons.iconscout.com/release/v4.0.0/css/line.css" rel='stylesheet' />
//     </Helmet>
//     <Container fluid className="px-0">
//       <Navi />
//       {children}
//       <Footer />
//     </Container>
//     </div>
//   )
// }


const Layout: React.FC = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div>
        <Helmet>
          <title>Climate Change 2022: Impacts, Adaptation and Vulnerability - IPCC Working Group II contribution to the Sixth Assessment Report</title>
          <link href="/favicon.ico" rel="shortcut icon" type="image/x-icon" />
          <link href="https://unpkg.com/boxicons@2.0.9/css/boxicons.min.css" rel="stylesheet" />
          <link href="https://unicons.iconscout.com/release/v4.0.0/css/line.css" rel="stylesheet" />
          <link rel="apple-touch-icon" sizes="180x180" href="https://www.ipcc.ch/site/assets/themes/ipcc/resources/img/favicon/apple-touch-icon.png" />
          <link rel="icon" type="image/png" sizes="32x32" href="https://www.ipcc.ch/site/assets/themes/ipcc/resources/img/favicon/favicon-32x32.png" />
          <link rel="icon" type="image/png" sizes="16x16" href="https://www.ipcc.ch/site/assets/themes/ipcc/resources/img/favicon/favicon-16x16.png" />
          <link rel="manifest" href="https://www.ipcc.ch/site/assets/themes/ipcc/resources/img/favicon/site.webmanifest" />
          <link rel="mask-icon" href="https://www.ipcc.ch/site/assets/themes/ipcc/resources/img/favicon/safari-pinned-tab.svg" color="#5492cd" />
          <link rel="shortcut icon" href="https://www.ipcc.ch/site/assets/themes/ipcc/resources/img/favicon/favicon.ico" />
          <link rel="mask-icon" href="../img/favicon/safari-pinned-tab.svg" color="#5492cd" />
          <link rel="shortcut icon" href="../img/favicon/favicon.ico" />
          <meta name="apple-mobile-web-app-title" content="IPCC" />
          <meta name="application-name" content="IPCC" />
          <meta name="msapplication-TileColor" content="#5492cd"></meta>
        </Helmet>
        <Container fluid className="px-0">
          <Navi />
          <SimpleReactLightbox>
            {children}
          </SimpleReactLightbox>
          <Footer />
        </Container>

      </div>
    </>
  )
}

export default Layout